import type {
  ObjectToolbarConfig,
  RegisterToolbarConfigArgs,
} from '@/blocks/object-toolbar';

/**
 * Assemble the object-toolbar config for the Controls register/list pages — both
 * the main Controls register and the Control Tests register (CUS-153). Register
 * toolbars are type-level: no `parentObject` (permissions resolve against the
 * type) and no `save` (a list page has no form). The register's multi-format
 * export (CSV / PDF / custom PDF) is surfaced as the toolbar's "Download" group —
 * one action per `ExportOption` returned by `useExportOptions`, the same
 * source that drives the legacy `ExportButton`.
 *
 * Pure so it can be unit-tested without rendering the page. Mirrors the Indicator
 * pilot's `buildIndicatorRegisterToolbarConfig` (CUS-150).
 */
export const buildControlRegisterToolbarConfig = ({
  title,
  counter,
  exportOptions,
  editRibbon,
}: RegisterToolbarConfigArgs): ObjectToolbarConfig => ({
  header: { title, counter },
  actions: {
    ...(editRibbon
      ? {
          overflow: [
            {
              id: 'edit',
              label: editRibbon.groupLabel,
              actions: [
                {
                  id: 'edit-ribbon',
                  label: editRibbon.label,
                  iconName: 'filter-lines',
                  onClick: editRibbon.onClick,
                },
              ],
            },
          ],
        }
      : {}),
    export: [
      {
        id: 'export',
        actions: exportOptions.map((option) => ({
          id: option.id,
          label: option.text,
          iconName: 'download-01',
          onClick: option.exportFunction,
          disabled: option.disabled,
        })),
      },
    ],
  },
});
